var render = function render(){var _vm=this,_c=_vm._self._c;return _c('noscript',[_c('iframe',{staticStyle:{"display":"none","visibility":"hidden"},attrs:{"src":`https://www.googletagmanager.com/ns.html?id=${this.publicId}`,"height":"0","width":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }